import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import WhyUs from "./pages/WhyUs"
import Faq from "./pages/Faq"
import Crypto from "./pages/Crypto"
import Forex from "./pages/Forex"
import Stocks from "./pages/Stocks"
import Stock from "./pages/Stock"
import Mystock from "./pages/Mystock"
import Stocklist from "./pages/Stocklist"
import Legal from "./pages/Legal"
import Policy from "./pages/Policy"
import Terms from "./pages/Terms"
import LoginPage from "./pages/LoginPage"
import Register from "./pages/Register"
import Forget from "./pages/Forget"
import Reset from "./pages/Reset"
import Dashboard from "./pages/Dashboard"
import Deposit from "./pages/Deposit"
import Deposit1 from "./pages/Deposit1"
import Deposit2 from "./pages/Deposit2"
import Deposit3 from "./pages/Deposit3"
import Deposit4 from "./pages/Deposit4"
import Withdraw from "./pages/Withdraw"
import Withdraw1 from "./pages/Withdraw1"
import Withdraw2 from "./pages/Withdraw2"
import Withdraw3 from "./pages/Withdraw3"
import Withdraw4 from "./pages/Withdraw4"
import Transfer from "./pages/Transfer"
import Assets from "./pages/Assets"
import Markets from "./pages/Markets"
import Marketdetails from "./pages/Marketdetails"
import Mining from "./pages/Mining"
import Retirement from "./pages/Retirement"
import Idetails from "./pages/Idetails"
import Coindetails from "./pages/Coindetails"
import Swap from "./pages/Swap"
import Trade from "./pages/Trade"
import Futures from "./pages/Futures"
import Subscribe from "./pages/Subscribe"
import Copyexpert from "./pages/Copyexpert"
import Copyprofile from "./pages/Copyprofile"
import Signal from "./pages/Signal"
import Portfolio from "./pages/Portfolio"
import Stake from "./pages/Stake"
import StakeDetails from "./pages/StakeDetails"
import Manage from "./pages/Manage"
import Chart from "./pages/Chart"
import Manager from "./pages/Manager"
import Contributions from "./pages/Contributions"
import Performance from "./pages/Performance"
import Upgradeplan from "./pages/Upgradeplan"
import Transaction from "./pages/Transaction"
import ImproveScore from "./pages/ImproveScore"
import Loanhistory from "./pages/Loanhistory"
import GetLoan from "./pages/GetLoan"
import Requirements from "./pages/Requirements"
import Loan from "./pages/Loan"
import Loandetails from "./pages/Loandetails"
import LoanForm from "./pages/LoanForm"
import LoanSummary from "./pages/LoanSummary"
import Components from "./pages/Components"
import Enrollment from "./pages/Enrollment"
import Enrollment1 from "./pages/Enrollment1"
import Enrollment2 from "./pages/Enrollment2"
import Enrollment3 from "./pages/Enrollment3"
import Enrollment4 from "./pages/Enrollment4"
import PlanDeposit from "./pages/PlanDeposit"
import PlanDeposit1 from "./pages/PlanDeposit1"
import PlanDeposit2 from "./pages/PlanDeposit2"
import PlanDeposit3 from "./pages/PlanDeposit3"
import RWithdraw from "./pages/RWithdraw"
import RWithdraw1 from "./pages/RWithdraw1"
import RWithdraw2 from "./pages/RWithdraw2"
import RWithdraw3 from "./pages/RWithdraw3"

import { UserProvider } from "./utils/UserContext";
import "./App.css"

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/components" element={<Components />} />
          <Route path="/whyus" element={<WhyUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/crypto" element={<Crypto />} />
          <Route path="/forex" element={<Forex />} />
          <Route path="/mystock" element={<Mystock />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/stocklist" element={<Stocklist />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/deposit1" element={<Deposit1 />} />
          <Route path="/deposit2" element={<Deposit2 />} />
          <Route path="/deposit3" element={<Deposit3 />} />
          <Route path="/deposit4" element={<Deposit4 />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/withdraw1" element={<Withdraw1 />} />
          <Route path="/withdraw2" element={<Withdraw2 />} />
          <Route path="/withdraw3" element={<Withdraw3 />} />
          <Route path="/withdraw4" element={<Withdraw4 />} />
          <Route path="/transfer" element={<Transfer />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<Forget />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/marketdetails" element={<Marketdetails />} />
          <Route path="/mining" element={<Mining />} />
          <Route path="/retirement" element={<Retirement />} />
          <Route path="/idetails" element={<Idetails />} />
          <Route path="/coindetails" element={<Coindetails />} />
          <Route path="/swap" element={<Swap />} />
          <Route path="/loan" element={<Loan />} />
          <Route path="/improvescore" element={<ImproveScore />} />
          <Route path="/getloan" element={<GetLoan />} />
          <Route path="/loanhistory" element={<Loanhistory />} />
          <Route path="/requirements" element={<Requirements />} />
          <Route path="/loandetails" element={<Loandetails />} />
          <Route path="/portfolio" element={<Manager />} />
          <Route path="/contributions" element={<Contributions />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/upgradeplan" element={<Upgradeplan />} />
          <Route path="/transaction" element={<Transaction />} />
          <Route path="/loanform" element={<LoanForm />} />
          <Route path="/manager" element={<Portfolio />} />
          <Route path="/loansummary" element={<LoanSummary />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/futures" element={<Futures />} />
          <Route path="/copyexpert" element={<Copyexpert />} />
          <Route path="/copyprofile" element={<Copyprofile />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/signal" element={<Signal />} />
          <Route path="/stake" element={<Stake />} />
          <Route path="/stakedetails" element={<StakeDetails />} />
          <Route path="/enrollment" element={<Enrollment />} />
          <Route path="/enrollment1" element={<Enrollment1 />} />
          <Route path="/enrollment2" element={<Enrollment2 />} />
          <Route path="/enrollment3" element={<Enrollment3 />} />
          <Route path="/enrollment4" element={<Enrollment4 />} />
          <Route path="/plandeposit" element={<PlanDeposit />} />
          <Route path="/plandeposit1" element={<PlanDeposit1 />} />
          <Route path="/plandeposit2" element={<PlanDeposit2 />} />
          <Route path="/plandeposit3" element={<PlanDeposit3 />} />
          <Route path="/rwithdraw" element={<RWithdraw />} />
          <Route path="/rwithdraw1" element={<RWithdraw1 />} />
          <Route path="/rwithdraw2" element={<RWithdraw2 />} />
          <Route path="/rwithdraw3" element={<RWithdraw3 />} />
          <Route path="/manage" element={<Manage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </UserProvider>
    </Router>
  )
}

export default App